@if (component) {
<div class="flex flex-middle"
     [class]="align">
    @switch (component.buttonType) {
    @case ('inline') {
    <href [link]="component.url || ''">
        <span inlineButton>
            <span *iCms="'label' of component"></span>
        </span>
    </href>
    }
    @case ('text') {
    <href [link]="component.url || ''">
        <span [buttonStyle]="'text-button'">
            <span *iCms="'label' of component"></span>
        </span>
    </href>
    }
    @default {
    <href [link]="component.url || ''">
        <span [buttonStyle]="component.buttonStyle || 'button'">
            <span *iCms="'label' of component"></span>
        </span>
    </href>
    }
    }
</div>
}